/**
 * (H) doc 27 §5: "Query key convention: `[tenantId, practiceId, resource,
 * params]` — tenant and practice are always in the key, so switching practice
 * can never show cached data from another."
 *
 * That is a disclosure rule, not a caching preference. A key without the
 * practice in it means one tenant's figures can be painted under another
 * tenant's header for as long as the cache lives.
 */
export interface KeyScope {
  tenantId: string;
  /** `null` when the identity is tenant-wide and has selected no practice. */
  practiceId: string | null;
}

export function scopedKey(
  scope: KeyScope,
  resource: string,
  params?: Readonly<Record<string, unknown>>,
): readonly unknown[] {
  return params === undefined
    ? [scope.tenantId, scope.practiceId, resource]
    : [scope.tenantId, scope.practiceId, resource, params];
}

/**
 * The key for `/me` itself, which cannot use `scopedKey`: the tenant is not
 * known until it resolves. The practice *is* in the key, because the active
 * practice changes both `active_practice` and the resolved permission set.
 */
export const meKey = (practiceId: string | null): readonly unknown[] => ["me", practiceId];
